export const OPEN_SIDEBAR_LINK_NAME = 'open-sidebar'

export function checkSidebarLink({ tab }: { tab: string }) {
  return tab && StatPage?.sidebar?.hasControlPanel?.(tab)
}

export default function openSidebarLink({ tab, focus }: { tab: string; focus: string }) {
  if (tab) {
    const res = StatPage?.sidebar?.openControlPanel?.(tab)
    if (false == res) return
  }
  if (focus) {
    switch (focus) {
      case 'add-banner': {
        const focusOn = async () => {
          try {
            const addBannerDropdown: HTMLElement = await waitForSelector('#crosstab-panel-add-banner-dropdown')
            addBannerDropdown?.click()
            const filterInput = await waitForSelector('.p-dropdown-filter', addBannerDropdown)
            filterInput?.focus()
          } catch {
            // skip
          }
        }
        void focusOn()
        break
      }
      case 'confidence-level': {
        const focusOn = async () => {
          try {
            const confidenceLevelSlider: HTMLElement = await waitForSelector('#crosstab-panel-confidence-level-slider')
            if (confidenceLevelSlider) {
              const handle = await waitForSelector('.p-slider-handle', confidenceLevelSlider)
              await focusBlink(handle)
              handle.focus()
            }
          } catch {
            // skip
          }
        }
        void focusOn()
        break
      }
      case 'significance-level': {
        const focusOn = async () => {
          try {
            const significanceLevelSlider: HTMLElement = await waitForSelector(
              '#crosstab-panel-significance-level-slider'
            )
            if (significanceLevelSlider) {
              const handle = await waitForSelector('.p-slider-handle', significanceLevelSlider)
              await focusBlink(handle)
              handle.focus()
            }
          } catch {
            // skip
          }
        }
        void focusOn()
        break
      }
      default: {
        break
      }
    }
  }
}

function waitForSelector(selector: string, parent: ParentNode = document, retries = 20): Promise<HTMLElement> {
  let retriesLeft = retries
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      const element = parent.querySelector(selector)
      if (element) {
        clearInterval(interval)
        resolve(element as HTMLElement)
      }
      retriesLeft--
      if (retriesLeft <= 0) {
        clearInterval(interval)
        reject()
      }
    }, 100)
  })
}

async function focusBlink(element: HTMLElement, stepDuration = 150, times = 3): Promise<void> {
  const waitTime = (resolve: (v: unknown) => void) => setTimeout(resolve, stepDuration)
  const blink = async () => {
    element.focus()
    await new Promise(waitTime)
    element.blur()
    await new Promise(waitTime)
  }
  for (let i = 0; i < times; i++) {
    await blink()
  }
}
